import {
  BILLING_TYPES_ENUMS,
  STORE_CARD_PAYMENT_TYPE_ENUMS,
} from "../system/globalEnums";

export const storeConstants = {
  RECEIPT_IMAGE_RESIZE_WIDTH: 200,
  GET_STORE_BY_ID: "GET_STORE_BY_ID",
  GET_STORES: "GET_STORES",
  ADD_STORE: "ADD_STORE",
  CREATE_NOTIFICATION: "CREATE_NOTIFICATION",
  GET_STORE_OWNERS: "GET_STORE_OWNERS",
  SET_CURRENT_STORE: "SET_CURRENT_STORE",
  REFETCH_STORE_CONFIGURATIONS: "REFETCH_STORE_CONFIGURATIONS",
  UPLOAD_LOGO: "UPLOAD_LOGO",
  UPDATE_RECEIPT_DETAILS: "UPDATE_RECEIPT_DETAILS",
  AG_GRID_MAX_COLUMN_WIDTH: 500, // Ag grid in pixels (as ag grid does not support percentage widths)
  AG_GRID_MIN_COLUMN_WIDTH: 75, // Ag grid in pixels
  REACT_DATA_TABLE_MAX_COLUMN_WIDTH: 80, //React data table in percentage
  REACT_DATA_TABLE_MIN_COLUMN_WIDTH: 5, //React data table in percentage
  SET_PERSISTENT_DRAGGABLE_NOTIFICATION:
    "SET_PERSISTENT_DRAGGABLE_NOTIFICATION",
  BILLING_TYPE: [
    {
      value: BILLING_TYPES_ENUMS.MONTHLY,
      label: BILLING_TYPES_ENUMS.MONTHLY,
    },
    {
      value: BILLING_TYPES_ENUMS.YEARLY,
      label: BILLING_TYPES_ENUMS.YEARLY,
    },
  ],
  GET_USER_NOTIFICATIONS: "GET_USER_NOTIFICATIONS",
  PAYOUT_INFORMATION: "PAYOUT_INFORMATION",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  UPDATE_AUDIT_SESSION_COMPLETE: "UPDATE_AUDIT_SESSION_COMPLETE",
  UPDATE_AUDIT_SESSION_COMPLETE_FALSE: "UPDATE_AUDIT_SESSION_COMPLETE_FALSE",
  STORE_TYPE: [
    {
      value: STORE_CARD_PAYMENT_TYPE_ENUMS.VERIFONE,
      label: "Verifone",
    },
    {
      value: STORE_CARD_PAYMENT_TYPE_ENUMS.PAYRILLIUM,
      label: "Payrillium",
    },
    {
      value: STORE_CARD_PAYMENT_TYPE_ENUMS.THIRD_PARTY,
      label: "Third-Party",
    },
  ],
  ADD_FREE_MONTHS: "ADD_FREE_MONTHS",
  GRANT_FREE_MONTHS: "Grant Free Month(s)",
  FREE_MONTH_COUNT_FIELD_NAME: "freeMonthsCount",
  PAYRILLIUM_BASE_URL_STORAGE_KEY: "payrilliumBaseUrl",
  PAYRILLIUM_DEVICE_NOT_FOUND_ERROR:
    "Device not found on network. Please try again later",
};
export const STORE_BILLING_STATUS = {
  TRIAL: "Trial",
  DEFAULT: "Default Value",
  ADMIN_GRANT: "Admin Granted Free Period",
  ACTIVE_SUBSCRIPTION: "Active Subscription",
  GRACE_PERIOD: "Grace Period", //Subscription status is grace period means payment is PAST_DUE or FAILED
  SERVICE_SUSPENDED: "Service Suspended", //Grace period over: Subscription status is canceled means service is suspended due to non-payment
};
